import { render, staticRenderFns } from "./highlights.vue?vue&type=template&id=73177602&"
import script from "./highlights.vue?vue&type=script&lang=js&"
export * from "./highlights.vue?vue&type=script&lang=js&"
import style0 from "./highlights.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports